import { trackEvent } from '@patrianna/analytics'
import { openDialog } from '@patrianna/dialog-manager'
import { nextTick } from '@patrianna/shared-utils'

import useBuilderCMSData from 'src/hooks/useBuilderCMSData'
import { useAppSelector } from 'src/store/hooks'
import { sweepstakeEnabledSelector } from 'src/store/modules/appConfig/selectors'
import {
  getJackpotPersonalExpireSelector,
  showJackpotPersonalExpireBadgeSelector,
} from 'src/store/modules/jackpots/selectors'

import useCountdownTimer from '../../VerifyEmail/utils/useCountdownTimer'

import { WidgetColor, WidgetsVariant } from './types'
import type { TimerWidget } from './types'

const STASH_WIDGET_DATA_MODEL = process.env.CMS_DATA_MODEL_STASH_WIDGET

export const useStashWidget = (): TimerWidget => {
  const personalExpire = useAppSelector(getJackpotPersonalExpireSelector)
  const showBadge = useAppSelector(showJackpotPersonalExpireBadgeSelector)
  const isScEnabled = useAppSelector(sweepstakeEnabledSelector)

  const { builderData: stashData, builderDataLoaded } = useBuilderCMSData(STASH_WIDGET_DATA_MODEL)
  const builderData = stashData[0]?.data

  const { timer, isTimerLoading } = useCountdownTimer(new Date(personalExpire).valueOf(), 1000, true)
  const imgSrc = builderData?.stashTimerUrl

  const handleStashClick = () => {
    nextTick().then(() => {
      trackEvent('stash_widget_clicked')
      openDialog({ dialogName: 'JACKPOTS_MY_STASH_WAITING_DIALOG' })
    })
  }

  return {
    id: WidgetsVariant.STASH,
    isWidgetVisible: Boolean(personalExpire && showBadge && isScEnabled && builderData && builderDataLoaded),
    imgSrc,
    imgAlt: builderData?.imageAlt || 'Stash',
    timer: isTimerLoading ? '...' : timer || '--:--:--',
    color: WidgetColor.TEAL,
    onClick: handleStashClick,
  }
}
